"use client";
import {
  useTypography
} from "./chunk-F5DLJCZM.mjs";

// src/typography.tsx
import { forwardRef } from "@kirvanobr/system";
import { useMemo } from "react";
import { jsx } from "react/jsx-runtime";
var Typography = forwardRef((props, ref) => {
  const { Component, getBaseProps, variant } = useTypography({
    ...props,
    ref
  });
  const Wrapper = useMemo(() => {
    return /* @__PURE__ */ jsx(Component, { ...getBaseProps() });
  }, [variant, getBaseProps]);
  return Wrapper;
});
Typography.displayName = "UI.Typography";
var typography_default = Typography;

export {
  typography_default
};
